const ulnar_nerve_pain_cubital_tunnel_entrapment = {
  name: "Ulnar Nerve Pain, Cubital Tunnel Entrapment",
  meta: {
    links: [
      { label: "Ulnar Nerve Decompression", url: "https://www.myorthopedicproblem.com/services/ulnar-nerve-decompression" }
    ]
  },
  conditions: {
    "age": "36-50,51-65,66-80,81 or older",
    "backhand_numbness": "no",
    "bend_wrist": "yes",
    "big_finger_numbness": "no",
    "pain_description": "dull",
    "pain_location": "medial",
    "palm_numbness": "yes",
    "small_finger_numbness": "yes",
    "swelling": "moderate",
    "trauma": "no"
  }
}

const trigger_finger_release = {
  name: "Trigger Finger Release",
  meta: {
    links: [
      { label: "Trigger Finger", url: "https://www.myorthopedicproblem.com/services/trigger-finger" }
    ]
  },
  conditions: {
    "age": "36-50,51-65,66-80,81 or older",
    "backhand_numbness": "no",
    "bend_wrist": "yes",
    "big_finger_numbness": "no",
    "extend_and_flex_fingers": "thumb,index,middle,ring,pinky",
    "fingers_locking": "thumb,index,middle,ring,pinky",
    "pain_description": "dull",
    "pain_location": "none",
    "palm_numbness": "no",
    "small_finger_numbness": "no",
    "swelling": "none",
    "trauma": "no"
  }
}

const carpal_tunnel = {
  name: "Carpal Tunnel",
  meta: {
    links: [
      { label: "Carpal Tunnel Syndrome", url: "https://www.myorthopedicproblem.com/services/carpal-tunnel-syndrome" }
    ]
  },
  conditions: {
    "age": "36-50,51-65,66-80,81 or older",
    "backhand_numbness": "no",
    "bend_wrist": "yes",
    "big_finger_numbness": "yes",
    "extend_and_flex_fingers": "thumb,index,middle,ring,pinky",
    "fingers_locking": "none",
    "pain_description": "dull",
    "pain_location": "none",
    "palm_numbness": "yes",
    "small_finger_numbness": "no",
    "swelling": "none,moderate",
    "trauma": "no"
  }
}

const ganglion_cyst = {
  name: "Ganglion Cyst",
  meta: {
    links: [
      { label: "Ganglion Cyst", url: "https://www.myorthopedicproblem.com/services/ganglion-cyst" }
    ]
  },
  conditions: {
    "backhand_numbness": "no",
    "bend_wrist": "limited,no",
    "big_finger_numbness": "no",
    "extend_and_flex_fingers": "all_normal",
    "fingers_locking": "none",
    "pain_description": "dull",
    "pain_location": "none",
    "palm_numbness": "no",
    "small_finger_numbness": "no",
    "swelling": "moderate,severe"
  }
}

const dupuytrens_contracture = {
  name: "Dupuytren's Contracture",
  meta: {
    links: [
      { label: "Dupuytren's Contracture", url: "https://www.myorthopedicproblem.com/services/dupuytrens-contracture" }
    ]
  },
  conditions: {
    "age": "36-50,51-65,66-80,81 or older",
    "backhand_numbness": "no",
    "bend_wrist": "yes",
    "big_finger_numbness": "no",
    "extend_and_flex_fingers": "thumb,index,middle,ring,pinky",
    "fingers_locking": "middle,ring,pinky",
    "pain_description": "dull",
    "pain_location": "none",
    "palm_numbness": "no",
    "small_finger_numbness": "yes",
    "swelling": "none,moderate",
    "trauma": "no"
  }
}

const dequerveins_tendonitis = {
  name: "DeQuervein's Tendonitis",
  meta: {
    links: [
      { label: "DeQuervein's Tendonitis", url: "https://www.myorthopedicproblem.com/services/de-quervains-tendinosis" }
    ]
  },
  conditions: {
    "age": "36-50,51-65,66-80,81 or older",
    "backhand_numbness": "yes",
    "bend_wrist": "no",
    "big_finger_numbness": "no",
    "extend_and_flex_fingers": "thumb",
    "pain_location": "none",
    "palm_numbness": "no",
    "small_finger_numbness": "no",
    "swelling": "moderate,severe",
    "trauma": "no"
  }
}

const tennis_elbow = {
  name: "Tennis Elbow",
  meta: {
    links: [
      { label: "Tennis Elbow", url: "https://www.myorthopedicproblem.com/services/tennis-elbow" }
    ]
  },
  conditions: {
    "age": "35 or younger,36-50,51-65,66-80,81 or older",
    "backhand_numbness": "no",
    "bend_wrist": "limited",
    "pain_description": "dull",
    "pain_location": "lateral",
    "palm_numbness": "no",
    "small_finger_numbness": "no",
    "swelling": "moderate",
    "trauma": "yes"
  }
}

const herberdens_nodes_of_distal_finger_DIP_joint = {
  name: "Herberdens Nodes of Distal Finger (DIP Joint)",
  meta: {},
  conditions: {
    "age": "36-50,51-65,66-80,81 or older",
    "backhand_numbness": "no",
    "bend_wrist": "yes",
    "big_finger_numbness": "no",
    "extend_and_flex_fingers": "all_normal",
    "fingers_locking": "none",
    "pain_description": "dull",
    "pain_location": "none",
    "palm_numbness": "no",
    "small_finger_numbness": "no",
    "swelling": "moderate,severe",
    "trauma": "yes"
  }
}

const radius_fracture_of_distal_wrist = {
  name: "Radius Fracture of Distal Wrist",
  meta: {},
  conditions: {
    "backhand_numbness": "no",
    "bend_wrist": "no",
    "big_finger_numbness": "yes",
    "extend_and_flex_fingers": "all_normal",
    "fingers_locking": "thumb,index,middle,ring,pinky",
    "pain_description": "sharp",
    "pain_location": "none",
    "palm_numbness": "yes",
    "small_finger_numbness": "no",
    "swelling": "severe",
    "trauma": "yes"
  }
}

const metacarpal_phalanx_fracture_of_the_hand={
  name: "Metacarpal Phalanx / Fracture of the Hand",
  meta: {},
  conditions: {
    "backhand_numbness": "no",
    "bend_wrist": "limited,no",
    "big_finger_numbness": "no",
    "extend_and_flex_fingers": "all_normal",
    "fingers_locking": "none",
    "pain_description": "sharp",
    "pain_location": "none",
    "palm_numbness": "no",
    "small_finger_numbness": "no",
    "swelling": "moderate,severe",
    "trauma": "yes"
  }
}

const scafoid_fracture_carpal_bone_of_wrist={
  name: "Scafoid Fracture / Carpal Bone of Wrist",
  meta: {},
  conditions: {
    "backhand_numbness": "no",
    "bend_wrist": "limited,no",
    "big_finger_numbness": "no",
    "extend_and_flex_fingers": "all_normal",
    "fingers_locking": "none",
    "pain_description": "dull",
    "pain_location": "none",
    "palm_numbness": "no",
    "small_finger_numbness": "no",
    "swelling": "moderate",
    "trauma": "yes"
  }
}



module.exports = {
  ulnar_nerve_pain_cubital_tunnel_entrapment,
  trigger_finger_release,
  carpal_tunnel,
  ganglion_cyst,
  dupuytrens_contracture,
  dequerveins_tendonitis,
  tennis_elbow,
  // herberdens_nodes_of_distal_finger_DIP_joint,
  // radius_fracture_of_distal_wrist,
  // metacarpal_phalanx_fracture_of_the_hand,
  // scafoid_fracture_carpal_bone_of_wrist,
}